<template>
    <div class="site-list">
        <p class="site-list__text">
            {{ $t('Login with the same user to all our platforms:') }}
        </p>
        <div class="site-list__icons-container">
            <div class="site-list__list-item" v-for="site in visibleSites" :key="site.site_id">
                <a
                    class="site-list__link"
                    :class="{ 'site-list__link--disabled': !getSiteUrl(site) }"
                    v-sanitize-href="getSiteUrl(site)"
                    rel="noopener"
                    target="_blank"
                >
                    <img
                        class="site-list__list-icon"
                        :src="getIconUrl(site.name)"
                        :alt="site.name"
                        @error="onIconError(site.site_id)"
                    />
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

const ORDERED_SITES = ['Envia', 'Fulfillment', 'Partners', 'Ecart Pay', 'Ecart API'];
const CDN_ICONS_BASE = 'https://cdn.ecart.com/images/icons';

export default {
    name: 'AppList',
    data() {
        return {
            siteUrls: {
                'Ecart Pay': 'https://ecartpay.com/',
                'Envia': 'https://envia.com/',
                'Fulfillment': 'https://fulfillment.envia.com/',
                'Partners': 'https://partners.envia.com/',
                'Ecart API': 'https://ecartapi.com/',
            },
            failedIcons: [],
        };
    },
    computed: {
        ...mapGetters('ui', ['sites']),
        visibleSites() {
            return ORDERED_SITES
                .map(name => this.sites.find(site => site.name === name))
                .filter(site => site && !this.failedIcons.includes(site.site_id));
        },
    },
    methods: {
        getIconUrl(name) {
            const slug = name
                .normalize('NFD')
                .replace(/\p{Diacritic}/gu, '')
                .replace(/\s+/g, '')
                .toLowerCase();
            return `${CDN_ICONS_BASE}/${slug}.png`;
        },
        onIconError(siteId) {
            if (!this.failedIcons.includes(siteId)) {
                this.failedIcons = [...this.failedIcons, siteId];
            }
        },
        getSiteUrl(site) {
            return this.siteUrls?.[site.name] || '';
        },
    },
};
</script>

<style lang="scss">
.site-list {
    margin: 30px 0;

    &__text {
        font-size: 0.9rem;
        font-weight: 500;
        color: $accounts-secondary-600;
        margin-bottom: 10px;
    }

    &__icons-container {
        align-items: center;
        display: flex;
        flex-wrap: wrap;
        gap: 5px;
    }

    &__list-item {
        flex-shrink: 0;
    }

    &__link {
        &--disabled {
            pointer-events: none;
        }
    }

    &__list-icon {
        height: 60px;
        width: 60px;
    }
}
</style>